import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';

// The FileManagerModal members used here; hide is an own property only
// while it is switched off.

/**
 * fof/upload's media manager ("Mes médias" in the composer) hides itself,
 * then shows "Nommez ce fichier téléchargé" for a file whose template has a
 * label (a .cle key, a PDF...). That second modal replaces the first during
 * its closing animation, whose transitionend then never fires: core's
 * ModalManager stays "closing" for good and ignores every later hide(), so
 * the new modal can't be closed at all - neither by its buttons nor by its
 * X (fof/upload 2.0.1).
 *
 * In that case the media manager isn't hidden first: the display-name
 * modal simply replaces it, as any non-stacked modal does. Everything else
 * (images, several files, a caller's own onSelect) is left to fof/upload.
 */
export default function fixMediaManagerDisplayNameModal() {
  override('ext:fof/upload/forum/components/FileManagerModal', 'onSelect', function (original) {
    // Read at click time: fof/upload is loaded by then, whatever the
    // extensions' order.
    const {
      supportsDisplayName
    } = flarum.reg.get('fof-upload', 'forum/utils/applyDisplayName');
    const files = this.selectedFiles.map(id => app.store.getById('files', id) ?? app.store.getById('shared-files', id)).filter(file => !!file);
    if (this.attrs.onSelect || !app.composer.editor || files.length !== 1 || !supportsDisplayName(files[0])) {
      original();
      return;
    }
    this.hide = () => {};
    try {
      original();
    } finally {
      delete this.hide;
    }
  });
}